import React, { useEffect, useRef } from "react";
import anime from "animejs";
import { FaLaptop, FaHeadphones, FaVideo } from "react-icons/fa";

function ITRequirements() {
  const itReqRef = useRef(null);

  useEffect(() => {
    const createObserver = (target, animationCallback, resetStyles) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              resetStyles();
              animationCallback();
            }
          });
        },
        { threshold: 0.1 }
      );

      if (target) {
        observer.observe(target);
      }
    };
    createObserver(
      itReqRef.current,
      () => {
        anime({
          targets: ".it-requirement-item",
          opacity: [0, 1],
          translateY: [20, 0],
          easing: "easeOutExpo",
          duration: 800,
          delay: anime.stagger(150),
        });
      },
      () => {
        const items = document.querySelectorAll(".it-requirement-item");
        items.forEach((item) => {
          item.style.opacity = "0";
          item.style.transform = "translateY(20px)";
        });
      }
    );
  }, []);

  return (
    <section
      id="it-requirements"
      ref={itReqRef}
      className="p-6 my-10 md:scroll-mt-44 scroll-mt-16 z-[4] max-w-2xl mx-auto bg-blue-300 rounded-md bg-opacity-80"
    >
      <h3 className="text-xl font-semibold mb-5 border-b-4 border-sdorange p-2 inline-block bg-sdorange bg-opacity-30">
        IT Requirements
      </h3>
      <p className="mb-3">
        Applicants must meet the following IT requirements:
      </p>
      <ul className="list-disc space-y-3">
        <li className="it-requirement-item text-gray-600 flex items-start space-x-4">
          <FaLaptop className="text-blue-500 mt-1" />
          <span>Internet-enabled devices (computer, laptop, tablet)</span>
        </li>
        <li className="it-requirement-item text-gray-600 flex items-start space-x-4">
          <FaHeadphones className="text-blue-500 mt-1" />
          <span>Speakers/headphones, webcam, & microphone</span>
        </li>
        <li className="it-requirement-item text-gray-600 flex items-start space-x-4">
          <FaVideo className="text-blue-500 mt-1" />
          <span>
            Video-based teaching platforms & the course’s Virtual Learning
            Environment (VLE)
          </span>
        </li>
      </ul>
    </section>
  );
}

export default ITRequirements;
